import {
  isRequired,
  isRequiredCheckbox,
  isRequiredCheckbox1,
  isRequiredSelect,
  isValidBranchName,
  isValidDescription,
  isValidEmail1,
  isValidOpeningHourse,
  isValidPhoneNumber,
  multiOptionRequiredCheckbox,
} from '../../../vendor/pages/Validation/Validation';
import { handleErrorResponse, handleSuccessResponse, vendorOrgnizationEdit } from '../../../services';
import { isSelect, isValidPostalCode } from '../../../common/validation/fieldRegex';
import { getStateVisible } from '../../../util';
import { getLatLngByAddress } from '../../../customHooks';
import { toast } from 'react-toastify';
import { Locale } from '../../../libraries';
export const handleChangeValue = (
  e,
  setFormValue,
  reactTrix,
  formValue,
  setErr,
  setApplyDisable
) => {
  const errorLogs = validation({
    ...formValue,
    [e.target.name]: e.target.value,
  });
  setErr && setErr(errorLogs);
  if (reactTrix) {
    const name = e.target.name;
    let value = e.target.data;
    setFormValue((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  } else {
    const { name, value, checked } = e.target;
    const errorLogs = validation({
      ...formValue,
      [name]: value,
    });
    setErr && setErr(errorLogs);
    if (name === 'postcode') {
      setFormValue((prevValues) => ({
        ...prevValues,
        [name]: value,
      }));
    } else {
      if (
        name === 'cash_payment' ||
        name === 'pay_online' ||
        name === 'serviceMyLocation' ||
        name === 'serviceCustomerLocation'
      ) {
        setFormValue((prevValues) => ({
          ...prevValues,
          [name]: checked,
        }));
      } else if (name === 'city') {
        setFormValue((prevValues) => ({
          ...prevValues,
          [name]: value,
        }));
      } else if (name === 'countrycode' || name === 'ccountrycode') {
        let countryCode = value.split(' ');
        let countryCode1 = countryCode[0].toString();
        setFormValue((prevValues) => ({
          ...prevValues,
          [name]: countryCode1,
        }));
      } else {
        setApplyDisable && setApplyDisable(false);
        let tempArray = name.split('.');
        if (tempArray && tempArray.length >= 2) {
          if (
            tempArray[1].toString() === 'open' ||
            tempArray[1].toString() === 'close'
          ) {
            const [, day, property] = name.match(/\[([^\]]+)\]\.([^\s.]+)/);
            if (property === "open") {
              setFormValue((prevState) => {
                const closeTime = prevState.bussiness_hours[day.toLowerCase()]?.close;

                return {
                  ...prevState,
                  bussiness_hours: {
                    ...prevState.bussiness_hours,
                    [day.toLowerCase()]: {
                      ...prevState.bussiness_hours[day.toLowerCase()],
                      open: value,
                      close: value >= closeTime ? null : closeTime,
                    },
                  },
                };
              });
            } else if (property === "close") {
              setFormValue((prevState) => {
                const openTime = prevState.bussiness_hours[day.toLowerCase()]?.open;

                return {
                  ...prevState,
                  bussiness_hours: {
                    ...prevState.bussiness_hours,
                    [day.toLowerCase()]: {
                      ...prevState.bussiness_hours[day.toLowerCase()],
                      close: value > openTime ? value : null,
                    },
                  },
                };
              });
            }
          } else if (tempArray[1].toString() === 'shop_open') {
            const day = name.match(/\[([^\]]+)\]/)[1].toLowerCase();
            setFormValue((prevState) => ({
              ...prevState,
              bussiness_hours: {
                ...prevState.bussiness_hours,
                [day]: {
                  ...(prevState.bussiness_hours &&
                    prevState.bussiness_hours[day]),
                  shop_open: checked,
                },
              },
            }));
          }
        } else {
          setFormValue((prevState) => ({
            ...prevState,
            [name]: value,
          }));
        }
      }
    }
  }
};
const removeUnwantedTagsEng = (content) => {
  if (!content) return '';
  const pattern =
    /<h\d+>\s*(null|&nbsp;)?\s*<\/h\d+>|<>\s*(null|&nbsp;)?\s*<\/>/gi;
  content = content.replace(pattern, '');
  return content;
};

const removeUnwantedTagsThai = (content) => {
  if (!content) return '';
  const pattern =
    /<h\d+>\s*(null|&nbsp;)?\s*<\/h\d+>|<>\s*(null|&nbsp;)?\s*<\/>/gi;
  content = content.replace(pattern, '');
  return content;
};

export const handleSubmit = async (
  e,
  formValue,
  setErr,
  formType,
  navigateUrl,
  navigate,
  closeButtonObject,
  setButtonDisabled,
  t,
  addressFormValue,
  setFormValue
) => {
  let err = {};
  e.preventDefault();
  err = validation(formValue, formType, t, addressFormValue);
  setErr(err);
  let response;
  formValue.venueEnglishDescription = removeUnwantedTagsEng(
    formValue.venueEnglishDescription,
  );
  formValue.venueThaiDescription = removeUnwantedTagsThai(
    formValue.venueThaiDescription,
  );
  if (
    (Object.keys(err).length === 2 &&
      err.venueEnglishDescription === '' &&
      err.venueThaiDescription === '') ||
    Object.keys(err).length === 0
  ) {
    try {
      setButtonDisabled(true);
      if (formType === 'accountEdit') {
        const isValid = await checkValidAddress(addressFormValue, t);
        if (!isValid) {
          setButtonDisabled(false);
          return;
        }
      }
      const formData = appendData(formValue, addressFormValue);
      response = await vendorOrgnizationEdit(formData);
      setFormValue && setFormValue((prev) => ({
        ...prev,
        shopImagesShow: []
      }))
      handleSuccessResponse(response, response.data.message);

    } catch (error) {
      handleErrorResponse(error);
    } finally {
      setButtonDisabled(false);
    }

  } else {
    setButtonDisabled(false);
  }
};

const checkValidAddress = async (addressFormValue, t) => {
  const response = await getLatLngByAddress(addressFormValue?.address);
  const countryFromAPI = response?.country_code;

  if (countryFromAPI && countryFromAPI !== addressFormValue?.country?.code) {
    toast.error(`${t('toastMessage.addressInCountry')} ${addressFormValue?.country?.name}`);
    return false;
  }
  return true
}




const appendData = (formValue, addressFormValue) => {
  const formData = new FormData();
  formData.append('website', formValue?.website);

  if (getStateVisible(addressFormValue?.country.name)) {
    formData.append("state", addressFormValue?.state);
  }
  formData.append("city", addressFormValue?.city?.name)
  formData.append("postcode", addressFormValue?.postalCode?.value)
  formData.append('location', addressFormValue?.address);
  formData.append("landmark", addressFormValue?.landmark)
  formData.append("area", addressFormValue?.area)
  formData.append("latitude", addressFormValue?.lat)
  formData.append("longitude", addressFormValue?.lng)

  let removeCountryNameCountryCode = formValue.countrycode
    ? formValue.countrycode.split('(').length > 0 &&
    formValue.countrycode.split('(')[0].toString()
    : '+66';
  formData.append(
    'phone',
    removeCountryNameCountryCode + ' ' + formValue.venuPhoneNumber,
  );
  if (formValue?.website) {
    formData.append('website', formValue.website);
  }
  formData.append('email', formValue.email);
  if (formValue?.venue_name && formValue.venue_name !== 'null') {
    formData.append('name', formValue?.venue_name || "");
    formData.append('name_thai', formValue?.venueThaiName || "");
  }
  formData.append('description_thai', formValue.venueThaiDescription);
  formData.append('description', formValue.venueEnglishDescription);
  formData.append(
    'service_at_bussiness_location',
    !formValue.serviceMyLocation || formValue.serviceMyLocation === 'null'
      ? ''
      : formValue.serviceMyLocation,
  );
  formData.append(
    'service_at_customer_location',
    !formValue.serviceCustomerLocation ||
      formValue.serviceCustomerLocation === 'null'
      ? ''
      : formValue.serviceCustomerLocation,
  );

  // -------------------------- append break time
  if (formValue?.breakTime?.start_time && formValue?.breakTime?.end_time) {
    formData.append('break_time[start_time]', formValue?.breakTime?.start_time);
    formData.append('break_time[end_time]', formValue?.breakTime?.end_time);
  }


  // -------------------------- append block time 

  if (formValue?.blockTime?.length) {
    formValue?.blockTime?.forEach((slot, index) => {
      formData.append(`block_time[][date]`, slot.date);
      formData.append(`block_time[][start_time]`, slot.start_time)
      formData.append(`block_time[][end_time]`, slot.end_time)
    })
  }
  else {
    formData.append(`block_time`, []);
  }

  // -------------------------- append bussiness hours 
  if (formValue.bussiness_hours) {
    Object.keys(
      Object.keys(formValue.bussiness_hours) && formValue.bussiness_hours,
    ).forEach((day) => {
      const dayData = formValue.bussiness_hours[day];
      formData.append(`bussiness_hours[${day}][open]`, dayData.open);
      formData.append(`bussiness_hours[${day}][close]`, dayData.close);
      formData.append(`bussiness_hours[${day}][shop_open]`, dayData.shop_open);
    });
  }

  if (formValue.shopImagesShow && formValue.shopImagesShow.length > 0) {
    formValue.shopImagesShow.forEach((image) => {
      if (image?.imageArea === "entry") {
        formData.append('entry[]', image.file);
      }
      else if (image?.imageArea === "reception") {
        formData.append('reception[]', image.file);
      }
      else if (image?.imageArea === "working") {
        formData.append('working_area[]', image.file);
      }
    });
  }

  if (!formValue.venue_name || formValue.venue_name === 'null')
    formData.append('is_freelancer', true);

  return formData;
};

export const validation = (formValue, formType, t, addressFormValue) => {
  const isRegisteredThaiCountry = sessionStorage.getItem('country') === 'Thailand';
  let checkErr = {};
  if (formType === 'deletetionRequest') {
    checkErr = isRequiredCheckbox1(
      formValue.deletetionRequestCheckbox1,
      { ...checkErr },
      'deletetionRequestCheckbox1',
      t,
    );
    checkErr = isRequiredCheckbox1(
      formValue.deletetionRequestCheckbox2,
      { ...checkErr },
      'deletetionRequestCheckbox2',
      t,
    );
  }
  if (formType === 'openingHourse') {
    checkErr = multiOptionRequiredCheckbox(
      formValue.serviceMyLocation,
      formValue.serviceCustomerLocation,
      { ...checkErr },
      'serviceLocation',
      `${t('validation.serviceLocationOption')}`,
      t,
    );
    checkErr = isRequiredCheckbox(
      formValue.breakTime,
      { ...checkErr },
      'breakTime',
      `${t('validation.breakTime')}`,
      t,
    );
    checkErr = isValidOpeningHourse(
      formValue.bussiness_hours,
      { ...checkErr },
      t,
    );

  }
  if (formType === 'accountEdit') {
    checkErr = isValidPhoneNumber(
      formValue.venuPhoneNumber,
      { ...checkErr },
      'venuPhoneNumber',
      `${t('field.phoneNumber')}`,
      '',
      t,
    );
    checkErr = isRequired(
      addressFormValue?.address,
      { ...checkErr },
      'address',
      `${t('field.address')}`,
      t,
    );
    checkErr = isRequired(
      addressFormValue?.area,
      { ...checkErr },
      'area',
      `${t('header.area')}`,
      t,
    );
    checkErr = isValidEmail1(formValue.email, { ...checkErr }, 'email', t);
    checkErr = isValidDescription(
      formValue.venueEnglishDescription,
      { ...checkErr },
      'venueEnglishDescription',
      `${isRegisteredThaiCountry ? t('validation.en') : t('validation.desc')}`,
      t,
    );

    if (getStateVisible(addressFormValue?.country?.name)) {
      checkErr = isSelect((addressFormValue?.state), { ...checkErr }, 'state', `${t("field.state")}`, t)
    }
    else {
      checkErr = isValidDescription(
        formValue.venueThaiDescription,
        { ...checkErr },
        'venueThaiDescription',
        `${t('validation.thai')}`,
        t,
      );
    }
    checkErr = isSelect((addressFormValue?.city), { ...checkErr }, 'city', t('field.city'), t)
    checkErr = isValidPostalCode((addressFormValue?.postalCode), { ...checkErr }, 'postalCode', `${t("field.postalCode")}`, t, addressFormValue?.country?.name)

  }
  if (formType === 'isEditBranchProfile') {
    checkErr = isValidBranchName(
      formValue.branchName,
      { ...checkErr },
      'branchName',
      `${t('field.branchName')}`,
      t,
    );
    checkErr = isRequired(
      formValue.address,
      { ...checkErr },
      'address',
      `${t('field.address')}`,
      t,
    );
    checkErr = isRequiredSelect(
      formValue.subDistrict,
      { ...checkErr },
      'subDistrict',
      `${t('field.subDistrict')}`,
      t,
    );
    checkErr = isRequiredSelect(
      formValue.postalCode,
      { ...checkErr },
      'postcode',
      `${t('field.postalCode')}`,
      t,
    );
    checkErr = isRequiredSelect(
      formValue.city,
      { ...checkErr },
      'city',
      `${t('field.city')}`,
      t,
    );
  }

  return checkErr;
};

export const handleApplyAll = (
  e,
  setApplyAll,
  openingHourseFormValue,
  setOpeningHourseFormValue,
  previousBusinessHours,
  setPreviousBusinessHours
) => {
  const isChecked = e.target.checked;
  setApplyAll(isChecked);

  // Define all days of the week
  const allDays = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

  if (isChecked) {
    setPreviousBusinessHours(openingHourseFormValue?.bussiness_hours);

    const mondayHours = openingHourseFormValue?.bussiness_hours?.monday;
    if (mondayHours) {
      const allDays = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
      const updatedHours = allDays.reduce((acc, day) => {
        acc[day] = {
          open: mondayHours?.open || null,
          close: mondayHours?.close || null,
          shop_open: mondayHours?.shop_open || false
        };
        return acc;
      }, {});
      setOpeningHourseFormValue({
        ...openingHourseFormValue,
        bussiness_hours: updatedHours
      });
    } else {
      console.warn("Monday's hours are not defined!");
    }
  }
  else {
    setOpeningHourseFormValue({
      ...openingHourseFormValue,
      bussiness_hours: previousBusinessHours,
    });
  }
};
